import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { url } from 'inspector';

@Component({
  selector: 'app-chi-siamo',
  templateUrl: './chi-siamo.component.html',
  styleUrls: ['./chi-siamo.component.scss'],
})
export class ChiSiamoComponent implements OnInit {
  @ViewChild('myElement2') myElement2!: ElementRef; // Referenza all'elemento nel template

  cardSelected = 1;
  isProcessing = false;
  heroData = {
    title: 'Una squadra con la passione per la tecnologia e formazione',
    subtitle: "Conoscici meglio: un team di esperti, appassionati di tecnologia e didattica, a tua disposizione per portare l'innovazione e il coding nella tua scuola. Con i nostri educatori di educazione al digitale aiutare i tuoi studenti ad essere pronti al futuro.",
    imgSrc: '../../../assets/img/floppy_platform.png',
    class: 'floppy-platform',
  };
  cardList: any = [
    {
      id: 1,
      tag: 'T/E/M',
      class: 'balloon',
      img: 'assets/img/icona gialla.svg',
      text: "Insegnare a utilizzare la <span class='w-700'>tecnologia</span> in modo utile e consapevole per il loro futuro e per migliorare la vita delle persone",
      url: '',
    },

    {
      id: 2,
      tag: 'T/E/M',
      img: 'assets/img/icona_gialla2.svg',
      class: 'balloon',
      text: "Favorire il rispetto, l’uguaglianza, la <span class='w-700'>cooperazione</span>, l’accettazione dell’altro, contribuendo alla costruzione di una società migliore",
      url: '',
    },
    {
      id: 3,
      tag: 'T/E/M',
      img: 'assets/img/icona_verde2.svg',
      text: "Attraverso la  <span class='violet w-700'>gamification</span>, creare un’esperienza che permetta di formarsi e imparare… divertendosi!",
      url: '',
      class: 'balloon',
    },
  ];


  count = 4;

  usersList = [
    {
      img: '../../../assets/img/filippo.svg',
      desc: 'Da oltre vent’anni lavoro nel settore IT e sono sempre attento alle novità che il mondo della tecnologia offre. Ricerca dell’innovazione, attenzione per la persona e forte entusiasmo mi contraddistinguono: sono per me di fondamentale importanza, di stimolo nella quotidianità e focus del mio operato. Sono il founder di Easycode, progetto con il quale forniamo a bambini e ragazzi strumenti e competenze utili per il loro futuro come il problem solving, la capacità di lavorare in gruppo, la creatività e la logica.',
      alt: 'Filippo - Founder',
    },
    {
      img: '../../../assets/img/chiara.svg',
      desc: 'Dopo una laurea in Filologia Moderna e un tirocinio in un ufficio stampa, sono entrata in un’azienda informatica avvicinandomi al mondo del digitale.  Nel 2016 con Filippo capisco che la mia missione è far conoscere il coding agli studenti! In Easycode mi occupo dell’organizzazione di tutti i corsi rivolti alle scuole primarie e secondarie. Il mio lavoro parte dalla ricerca di istituti interessati e prosegue con l’organizzazione dei corsi in base alle singole necessità.',
      alt: 'Chiara - Responsabile Progetto',
    },
    {
      img: '../../../assets/img/vittoria.svg',
      desc: 'Dopo una laurea magistrale in Psicologia per il Benessere, ho scoperto la passione e l’interesse per la tecnologia e il mondo scolastico.   Come educatrice digitale in Easycode, condivido con studenti e insegnanti esperienze e attività per imparare a programmare, ma utili anche per sviluppare importanti competenze sociali. E quando la scuola è chiusa? Supporto Chiara nella ricerca di nuovi contatti, idee e collaborazioni per far crescere sempre di più il progetto! ',
      alt: 'Vittoria - Educatrice Digitale',
    },
    {
      img: '../../../assets/img/francesco.svg',
      desc: 'Ho studiato filosofia e programmazione, lavorato come assistente perito, developer e analista funzionale, ma dopo tante esperienze diverse ho trovato felicità e soddisfazione dall’insegnamento. Ora sono un educatore digitale in Easycode e lavoro principalmente con studenti della scuola primaria e secondaria. Per me insegnare coding è un’opportunità unica per far conoscere a bambini e ragazzi logiche e competenze fondamentali per il loro futuro.',
      alt: 'Francesco - Educatore Digitale',
    },
    {
      img: '../../../assets/img/elena.svg',
      desc: 'Laureata in Comunicazione, media e pubblicità e in seguito diplomata in sceneggiatura, ho trovato nel Digital Marketing la mia strada. Attraverso i Social Media, ogni giorno mi occupo di far conoscere il progetto Easycode agli influencer della didattica, cercando la via migliore per costruire una rete di contatti innovativa e vivace!',
      alt: 'Elena - Digital Marketing Specialist',
    },

    {
      img: '../../../assets/img/antonella.svg',
      desc: 'Laureata in informatica, dopo varie esperienze da programmatrice mi avvicino al mondo scolastico e dell’insegnamento come freelance. Conosco Filippo e Chiara nel 2017 e mi appassiono fin da subito al loro progetto. Collaboro stabilmente con Easycode, portandone il metodo educativo e i corsi in numerose scuole: dall’unplugged a Scratch, dalla robotica educativa ad App Inventor, insegno agli studenti le basi della programmazione in modo semplice e divertente!',
      alt: 'Antonella - Educatrice Digitale',
    },
    {
      img: '../../../assets/img/martina.svg',
      desc: 'Dopo una laurea in Teoria e Tecnologia della Comunicazione scopro che il mondo dell’informatica negli ultimi anni ha sviluppato interesse anche verso gli studenti più giovani e mi appassiono a questa sfida. Dal 2023 inizio il mio percorso come educatrice digitale nelle scuole con Easycode, svolgendo corsi di Robotica, Scratch e Arduino e portando la mia passione nelle classi. Il coding per me è un’opportunità per affrontare i problemi con creatività e cerco di trasmettere questo messaggio a tutti i bambini e i ragazzi che incontro!',
      alt: 'Martina - Educatrice Digitale',
    }
  ];
  constructor() {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {


    const element2 = this.myElement2.nativeElement;
    const mc2 = new Hammer(element2);

    // Aggiungi i riconoscitori per gestire eventi specifici

    mc2.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.cardSelected > 1) {
          this.cardSelected--;
        } else {
          this.cardSelected = 3;
        }
      } else if (ev.type === 'panleft') {
        if (this.cardSelected < 3) {
          this.cardSelected++;
        } else {
          this.cardSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });
  }

  changeSlideCard(id: number) {
    this.cardSelected = id;
  }
}
